import React from 'react';

function FullScreenIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M16.9,5.5v3c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5V6.3h-2.3c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2h3.1c0.2,0,0.4,0.1,0.5,0.2C16.8,5.1,16.9,5.3,16.9,5.5z M6.9,13.7H4.6v-2.2c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.4,0.1-0.5,0.2c-0.1,0.1-0.2,0.3-0.2,0.5v3c0,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.2h3.1c0.2,0,0.4-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.4-0.2-0.5C7.3,13.8,7.1,13.7,6.9,13.7z M20,3.3v13.5c0,0.4-0.2,0.8-0.5,1.1c-0.3,0.3-0.7,0.4-1.1,0.4H1.5c-0.4,0-0.8-0.2-1.1-0.4C0.2,17.5,0,17.1,0,16.7V3.3c0-0.4,0.2-0.8,0.5-1.1c0.3-0.3,0.7-0.4,1.1-0.4h16.9c0.4,0,0.8,0.2,1.1,0.4C19.8,2.5,20,2.9,20,3.3z M18.5,16.7V3.3H1.5v13.5H18.5z"/>
    </svg>
  );
}

export default FullScreenIcon;
